import { render, staticRenderFns } from "./ProductVariantPricingsFormItems.vue?vue&type=template&id=41b269f9&"
import script from "./ProductVariantPricingsFormItems.vue?vue&type=script&lang=js&"
export * from "./ProductVariantPricingsFormItems.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantPricingsFormItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b269f9')) {
      api.createRecord('41b269f9', component.options)
    } else {
      api.reload('41b269f9', component.options)
    }
    module.hot.accept("./ProductVariantPricingsFormItems.vue?vue&type=template&id=41b269f9&", function () {
      api.rerender('41b269f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductVariantPricingsFormItems.vue"
export default component.exports